import React from "react";
import ContentLoader from "react-content-loader";

const LoaderNotifications = (props) => {
  return (
    <ContentLoader
      viewBox="0 0 700 360"
      width="100%"
      height="auto"
      preserveAspectRatio="xMidYMid meet"
      backgroundColor="#f5f5f5"
      foregroundColor="#dbdbdb"
      {...props}
    >
      {/* Titre */}
      <rect x="20" y="18" rx="6" ry="6" width="220" height="18" />

      {/* Item 1 */}
      <circle cx="30" cy="74" r="6" />
      <rect x="48" y="60" rx="6" ry="6" width="230" height="14" />
      <rect x="560" y="60" rx="6" ry="6" width="110" height="12" />
      <rect x="48" y="82" rx="6" ry="6" width="520" height="12" />

      {/* Item 2 */}
      <circle cx="30" cy="132" r="6" />
      <rect x="48" y="118" rx="6" ry="6" width="260" height="14" />
      <rect x="560" y="118" rx="6" ry="6" width="90" height="12" />
      <rect x="48" y="140" rx="6" ry="6" width="480" height="12" />

      {/* Item 3 */}
      <circle cx="30" cy="190" r="6" />
      <rect x="48" y="176" rx="6" ry="6" width="240" height="14" />
      <rect x="560" y="176" rx="6" ry="6" width="120" height="12" />
      <rect x="48" y="198" rx="6" ry="6" width="540" height="12" />

      {/* Item 4 */}
      <circle cx="30" cy="248" r="6" />
      <rect x="48" y="234" rx="6" ry="6" width="210" height="14" />
      <rect x="560" y="234" rx="6" ry="6" width="100" height="12" />
      <rect x="48" y="256" rx="6" ry="6" width="500" height="12" />

      {/* Bouton "Voir plus" */}
      <rect x="260" y="304" rx="12" ry="12" width="180" height="38" />
    </ContentLoader>
  );
};

export default LoaderNotifications;
